import i18next from 'i18next';

export const VERTICALS = [
  {
    label: '---',
    value: '---'
  },
  {
    label: i18next.t('menu.brand.verticals.automotive'),
    value: 'automotive'
  },
  {
    label: i18next.t('menu.brand.verticals.beauty'),
    value: 'beauty'
  },
  {
    label: i18next.t('menu.brand.verticals.business'),
    value: 'business'
  },
  {
    label: i18next.t('menu.brand.verticals.consumer'),
    value: 'consumer'
  },
  {
    label: i18next.t('menu.brand.verticals.education'),
    value: 'education'
  },
  {
    label: i18next.t('menu.brand.verticals.fashion'),
    value: 'fashion'
  },
  {
    label: i18next.t('menu.brand.verticals.food'),
    value: 'food'
  },
  {
    label: i18next.t('menu.brand.verticals.healthcare'),
    value: 'healthcare'
  },
  {
    label: i18next.t('menu.brand.verticals.home'),
    value: 'home'
  },
  {
    label: i18next.t('menu.brand.verticals.logistics'),
    value: 'logistics'
  },
  {
    label: i18next.t('menu.brand.verticals.media'),
    value: 'media'
  },
  {
    label: i18next.t('menu.brand.verticals.pet'),
    value: 'pet'
  },
  {
    label: i18next.t('menu.brand.verticals.professional'),
    value: 'professional'
  },
  {
    label: i18next.t('menu.brand.verticals.retail'),
    value: 'retail'
  },
  {
    label: i18next.t('menu.brand.verticals.software'),
    value: 'software'
  },
  {
    label: i18next.t('menu.brand.verticals.travel'),
    value: 'travel'
  },
  {
    label: i18next.t('menu.brand.verticals.nonprofits'),
    value: 'nonprofits'
  }
];
